import { shape, number, string } from 'prop-types';

export const ArticulosReposicionType = shape({
  id: string,
  unidadesPropuestas: number,
  unidades: number,
  descripcion: string,
  stock: number,
  codigoEdi: string,
});
